module.exports = __webpack_public_path__ + "static/img/logo_fotter.7512810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_fotter.png
// module id = df7p
// module chunks = 16